import React from "react";
import { Grid, Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";

import Section from "../../../elements/Section";
import SectionHeader from "../../../elements/SectionHeader";
import DescriptionList from "../../../elements/DescriptionList";
import FormattedDate from "../../../elements/FormattedDate";
import { FORMAT_DATE } from "../../../utils/formatting";
import I18nText from "../../../elements/I18nText";
import { PrimaryButton } from "../../../elements/Button";
import { useAuth, PERMISSIONS } from "../../../auth";
import MaintenanceIndicator from "../Maintenance/MaintenanceIndicator";

const Maintenance = ({ device }) => {
  const { hasPermission } = useAuth();
  const canManage = hasPermission(device.permissions, PERMISSIONS.MAINTENANCE);
  const { maintenance } = device;

  const options = maintenance
    ? [
        {
          label: "devices.maintenance.common.startDate",
          value: (
            <FormattedDate format={FORMAT_DATE}>
              {maintenance.startDate}
            </FormattedDate>
          )
        },
        {
          label: "devices.maintenance.common.intervalDays",
          value: (
            <I18nText
              values={{
                days: maintenance.intervalDays
              }}
            >
              devices.maintenance.common.intervalDaysValue
            </I18nText>
          )
        },
        {
          label: "devices.maintenance.common.status",
          value: <MaintenanceIndicator status={maintenance.status} />
        }
      ]
    : [];

  return (
    <Section>
      <SectionHeader>
        <I18nText>devices.status.sections.maintenance</I18nText>
      </SectionHeader>

      {maintenance ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DescriptionList options={options} />
          </Grid>
          <Grid item xs={12}>
            <PrimaryButton
              component={Link}
              to={`/devices/${device.id}/maintenance`}
            >
              <I18nText>devices.maintenance.actions.viewAll</I18nText>
            </PrimaryButton>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box color="text.secondary" fontSize={14}>
              <I18nText>devices.maintenance.emptyState</I18nText>
            </Box>
          </Grid>
          {canManage && (
            <Grid item xs={12}>
              <PrimaryButton
                component={Link}
                to={`/devices/${device.id}/maintenance/new`}
                icon={<AddIcon />}
              >
                <I18nText>devices.maintenance.actions.new</I18nText>
              </PrimaryButton>
            </Grid>
          )}
        </Grid>
      )}
    </Section>
  );
};

export default Maintenance;
